import { useNavigate } from "react-router-dom";
import styled, { css } from "styled-components";
import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useContext, useEffect, useState } from "react";
import { EmployeeContext } from "../../context/EmployeeContext";
import { isAdmin } from "../../utils/util";
import { SoecoButton } from "../../components/SoecoButton";
import { ClipboardList, PackagePlus, TextSearch, ShoppingCart } from "lucide-react";
import { CompanyContext } from "../../context/CompanyContext";
import { useGetCompany, useGetTopCompany } from "../../hooks/companyHooks";
import { Company } from "../../types";
import { useGenerateLoginLink } from "../../hooks/employeeHooks";
import { useSnackBar } from "../../context/SnackbarContext";

export const MenuIcons = () => {
    const theme = useTheme();
    const { employee } = useContext(EmployeeContext);
    const navigate = useNavigate();
    const { company } = useContext(CompanyContext);
    const { data: topCompany } = useGetTopCompany(employee.companyId);
    const { data: companyData } = useGetCompany(employee.companyId);
    // const { data: loginLink } = useGetLoginLink(employee.id);
    const { mutateAsync: generateLoginLink, isPending } = useGenerateLoginLink();

    const [mainCompany, setMainCompany] = useState<Company | undefined>(companyData);
    const snackBar = useSnackBar();
    const handleMarketplace = async () => {
        try {
            const data = await generateLoginLink(employee.id);

            console.log("LoginLink response:", data);

            if (data?.login_url) {
                window.open(data.login_url, "_blank");
            }
        } catch (error) {
            snackBar.showSnackBar("Failed to get login link", "error");
            console.error("Failed to get login link:", error);
        }
    };
    useEffect(() => {
        if (!companyData) return;

        if (!companyData.createdBy) {
            setMainCompany(companyData);
        } else if (topCompany) {
            setMainCompany(topCompany);
        }
    }, [companyData, topCompany]);

    // useEffect(() => {
    //     if (!companyData) return;
    //     if (companyData.createdBy === null) setMainCompany(companyData);
    //     if (companyData.createdBy) {
    //         const { data: comp } = useGetCompany(companyData.createdBy);
    //         console.log("comp", comp);
    //         setMainCompany(comp);
    //     }
    // }, [companyData]);

    return (
        <MenuWrapper>
            {isAdmin(employee) ? (
                <>
                    <SoecoButton icon onClick={() => navigate("/admin")}>
                        <IconWrapper aria-label="Admin, link">
                            <ClipboardList
                                style={{
                                    color: theme.palette.primary.main,
                                    transition: "color 0.2s ease",
                                }}
                                size={96}
                                onMouseEnter={e =>
                                    (e.currentTarget.style.color = theme.palette.secondary.main)
                                }
                                onMouseLeave={e =>
                                    (e.currentTarget.style.color = theme.palette.primary.main)
                                }
                            />
                        </IconWrapper>
                    </SoecoButton>
                    <Typography
                        color="#8c8c8c"
                        fontWeight={600}
                        fontSize={24}
                        marginTop={"4px"}
                        sx={{ fontFamily: "Inter, sans-serif" }}
                    >
                        Admin
                    </Typography>
                </>
            ) : (
                <></>
            )}
            <SoecoButton
                icon
                onClick={() => navigate(`/companies/${employee.companyId}/createInventory`)}
            >
                <IconWrapper aria-label="Create Inventory, link">
                    <PackagePlus
                        style={{
                            color: theme.palette.primary.main,
                            transition: "color 0.2s ease",
                        }}
                        size={96}
                        onMouseEnter={e =>
                            (e.currentTarget.style.color = theme.palette.secondary.main)
                        }
                        onMouseLeave={e =>
                            (e.currentTarget.style.color = theme.palette.primary.main)
                        }
                    />
                </IconWrapper>
            </SoecoButton>
            <Typography
                color="#8c8c8c"
                fontWeight={600}
                fontSize={24}
                marginTop={"4px"}
                sx={{ fontFamily: "Inter, sans-serif" }}
            >
                Create Inventory
            </Typography>
            <SoecoButton
                icon
                onClick={() => navigate(`/companies/${employee.companyId}/inventories/`)}
            >
                <IconWrapper aria-label=" Inventory List, link">
                    <TextSearch
                        style={{
                            color: theme.palette.primary.main,
                            transition: "color 0.2s ease",
                        }}
                        size={96}
                        onMouseEnter={e =>
                            (e.currentTarget.style.color = theme.palette.secondary.main)
                        }
                        onMouseLeave={e =>
                            (e.currentTarget.style.color = theme.palette.primary.main)
                        }
                    />
                </IconWrapper>
            </SoecoButton>
            <Typography
                color="#8c8c8c"
                fontWeight={600}
                fontSize={24}
                marginTop={"4px"}
                sx={{ fontFamily: "Inter, sans-serif" }}
            >
                Inventory List
            </Typography>
            {mainCompany && mainCompany.accessMarketplace ? (
                <>
                    <SoecoButton
                        icon
                        // onClick={() => navigate(`/companies/${employee.companyId}/inventories/`)}
                        onClick={() => {
                            // handleMarketplace().catch(error =>
                            //     console.error("Failed to redirect to marketplace:", error),
                            // );
                            void handleMarketplace();
                        }}
                    >
                        <IconWrapper aria-label="Marketplace, link">
                            <ShoppingCart
                                style={{
                                    color: theme.palette.primary.main,
                                    transition: "color 0.2s ease",
                                }}
                                size={96}
                                onMouseEnter={e =>
                                    (e.currentTarget.style.color = theme.palette.secondary.main)
                                }
                                onMouseLeave={e =>
                                    (e.currentTarget.style.color = theme.palette.primary.main)
                                }
                            />
                        </IconWrapper>
                    </SoecoButton>
                    <Typography
                        color="#8c8c8c"
                        fontWeight={600}
                        fontSize={24}
                        marginTop={"4px"}
                        sx={{ fontFamily: "Inter, sans-serif" }}
                    >
                        Marketplace
                    </Typography>
                </>
            ) : null}
        </MenuWrapper>
    );
};

const MenuWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    margin-top: 50px;
    margin-bottom: 50px;
`;

const IconWrapper = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 130px;
    @media (max-width: 400px) {
        font-size: 100px;
    }
`;
